import React from 'react';
import { Grid } from '@material-ui/core';
import { IGroup } from 'parent-portal/group/models';

import CarouselCard from './CarouselCard';

const GroupsCarousel = ({ groups }: { groups: IGroup[] }) => {
    return (
        <Grid container style={{ padding: 10, borderRadius: 10 }}>
            <Grid item style={{ overflowY: 'hidden' }}>
                <div style={{ display: 'inline-flex', overflowY: 'hidden', padding: '3px 0' }}>
                    {groups.map((x) => (
                        <CarouselCard key={x.id} group={x} />
                    ))}
                </div>
            </Grid>
        </Grid>
    );
};

export default GroupsCarousel;
